/**
 * Environment configuration. The only remaining value is this console's own
 * origin (`appOrigin`), derived at runtime from `window.location.origin` and
 * used as the centralized-login `returnUrl` origin. Auth and product-API hosts
 * are resolved at runtime from same-origin `GET /api/bootstrap` — there are no
 * build-time `VITE_*` origin knobs.
 */
export interface AppEnv {
  /** This console's own origin, derived from the browser at runtime. */
  appOrigin: string;
}

function stripTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

function readBrowserOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  // Dev/test fallback (jsdom supplies window.location.origin, so this is only
  // hit in a non-browser context). The dev server runs on 5176 (see vite.config).
  return 'http://localhost:5176';
}

export const env: AppEnv = {
  appOrigin: stripTrailingSlash(readBrowserOrigin()),
};
